<template>
  <div
    :class="[
      'gfb-radio-container',
      { required: required },
      { 'pill-error': !!error },
      { multiple: multiple },
    ]"
  >
    <p v-if="label" class="w-100 font-16-500 mb-2">
      {{ label }}{{ required ? " *" : "" }}
    </p>
    <span v-if="subtitle" class="w-100 mb-2 d-block">{{ subtitle }}</span>
    <div class="d-flex flex-wrap">
      <radio-input
        v-for="opt in normalizedOptions"
        :key="opt.inputId"
        :type="multiple ? 'checkbox' : 'radio'"
        :inputId="opt.inputId"
        :name="name"
        :value="opt.value"
        :checked="isChecked(opt.value)"
        :label="opt.text"
        :disabled="disabled"
        @change="handleChange(opt.value)"
      />
    </div>
    <form-error nonInput v-if="error">{{ error }}</form-error>
  </div>
</template>

<script>
export default {
  name: "gfb-radio-group",
  props: {
    label: { type: String, default: "" },
    name: { type: String, required: true },
    options: { type: Array, required: true },
    value: { default: null },
    required: { type: Boolean, default: false },
    error: { default: null },
    subtitle: { type: String, default: "" },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["change"],
  computed: {
    normalizedOptions() {
      return this.options.map((opt) => {
        if (typeof opt === "object" && opt !== null) {
          return {
            text: opt.text ?? String(opt.value),
            value: opt.value,
            inputId: `${this.name}-${opt.text ?? opt.value}`,
          }
        }
        return { text: String(opt), value: opt, inputId: `${this.name}-${opt}` }
      })
    },
  },
  methods: {
    isChecked(val) {
      if (this.multiple) {
        return Array.isArray(this.value) && this.value.includes(val)
      }
      return this.value === val
    },
    handleChange(val) {
      if (this.multiple) {
        const current = Array.isArray(this.value) ? this.value : []
        const next = current.includes(val)
          ? current.filter((v) => v !== val)
          : [...current, val]
        this.$emit("change", next)
      } else {
        this.$emit("change", val)
      }
    },
  },
}
</script>
